
import { Mapviewer } from '@/views/mapview/Mapviewer'

class application {
    constructor() {
        this.data1 = 0
        this.data2 = 0
        this.data3 = 0

        this.mapviewer = undefined
        console.log(' application constructor ')
    }
    destroy() {
        console.log(' application destroy ')
        if (this.mapviewer) { this.mapviewer.destroy() }
    }

    create(el, options) {
        let v = new Mapviewer(el, options)
        if (!v) {
            console.log(' application create failed')
            return false
        }

        v.create(options.wid)
        this.mapviewer = v
        console.log(' application create ')
    }

    // print() {
    //     console.log(this)
    // }
}

var g_app = new application()
export { application, g_app }
